import React from 'react';
import { ShortBody } from 'components/Typography';
import { Grid, CircularProgress, Box } from '@material-ui/core';
import PasswordInputField from 'components/InputField/Password';
import { StyledDivider } from 'containers/MyAccountPage/styles';
import { OrangeButton } from 'components/Button';
import { injectIntl, IntlShape } from 'react-intl';
import messages from 'containers/MyAccountPage/messages';
import { translate } from 'helpers/intl';
import { get } from 'lodash';

const Content = (props: ContentType) => {
  const {
    error,
    helperText,
    handleChange,
    handleBlur,
    value,
    handleSubmit,
    isLoading,
    handleClose,
  } = props;
  return (
    <>
      <Box px={3}>
        <ShortBody weight="400">
          {translate(get(messages, 'confimPasswordSubTitle'), props)}
        </ShortBody>
        <PasswordInputField
          name="password"
          label={translate(get(messages, 'password'), props)}
          placeholder={translate(get(messages, 'password'), props)}
          error={error}
          helperText={helperText}
          handleChange={handleChange}
          handleBlur={handleBlur}
          value={value}
        />
      </Box>
      <Box mt={5} mb={2}>
        <StyledDivider />
      </Box>
      <Box px={3}>
        <Grid container justify="flex-end" spacing={2}>
          <Grid item>
            <OrangeButton onClick={handleClose}>
              {translate(get(messages, 'cancel'), props)}
            </OrangeButton>
          </Grid>
          <Grid item>
            <OrangeButton
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
            >
              {translate(get(messages, 'valid'), props)}
              {isLoading ? (
                <CircularProgress
                  color="inherit"
                  size={20}
                  style={{ marginLeft: '5px' }}
                />
              ) : null}
            </OrangeButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export interface ContentType {
  error: string | false | undefined;
  helperText: string | false | undefined;
  handleChange: Function;
  handleBlur: Function;
  value: string;
  intl: IntlShape;
  handleSubmit: Function;
  isLoading: boolean;
  handleClose: Function;
}

export default injectIntl(Content);
